(function () {
  'use strict';

  // ---------- tiny helpers ----------
  const $$ = (root, sel) => Array.from(root.querySelectorAll(sel));
  const $1 = (root, sel) => root.querySelector(sel);

  function debounce(fn, wait) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, arguments), wait);
    };
  }

  // ---------- read our injected JSON index ----------
  function buildVariantIndex() {
    const tag = document.getElementById('wot-upsell-index');
    if (!tag) return new Map();
    try {
      const data = JSON.parse(tag.textContent || '{}');
      const map = new Map();
      (data.variants || []).forEach(rec => {
        if (rec && rec.vid && rec.weightKg && rec.type) {
          map.set(String(rec.vid), { type: rec.type, weightKg: Number(rec.weightKg) });
        }
      });
      return map;
    } catch (e) {
      return new Map();
    }
  }

  const VARIANT_INDEX = buildVariantIndex();

  // ---------- area source ----------
  function readAreaM2() {
    // Adjust selector if your area input differs:
    // Expect a single numeric input inside .m2-input-section
    const input = document.querySelector('.m2-input-section input[type="number"], .m2-input-section input');
    if (!input) return null;
    const val = parseFloat((input.value || '').toString().replace(',', '.'));
    return Number.isFinite(val) && val > 0 ? val : null;
  }

  // ---------- quantity math ----------
  function computeQty(type, weightKg, areaM2) {
    if (!areaM2 || !weightKg || weightKg <= 0) return null;
    let needed;
    if (type === 'grout') {
      // formula: area * 0.4 / weight
      needed = (areaM2 * 0.4) / weightKg;
    } else if (type === 'adhesive') {
      // formula: area * 4 / weight
      needed = (areaM2 * 4) / weightKg;
    } else {
      return null;
    }
    // Business rule: round up to integer, min 1
    const qty = Math.max(1, Math.ceil(needed));
    return qty;
  }

  // ---------- per-card processing ----------
  function extractVariantId(card) {
    // Primary: the app sets lb-variant-id on the host node
    const vidAttr = card.getAttribute('lb-variant-id');
    if (vidAttr) return String(vidAttr);

    // Fallback: if a select exists (variant picker inside this card)
    const select = card.querySelector('.lb-variant-picker select');
    if (select && select.value) return String(select.value);

    return null;
  }

  function updateCardQuantity(card, areaM2) {
    const vid = extractVariantId(card);
    if (!vid) return;

    const meta = VARIANT_INDEX.get(String(vid));
    if (!meta) {
      // No record in our index—do nothing (we only trust tag-based data)
      return;
    }

    const qtyInput = card.querySelector('input.lb-qty-count[type="number"]');
    if (!qtyInput) return;

    const qty = computeQty(meta.type, meta.weightKg, areaM2);
    if (!qty) return;

    // Only set once unless value is empty/1 (don’t fight the customer)
    const current = parseInt(qtyInput.value || '0', 10);
    if (!current || current === 1) {
      qtyInput.value = String(qty);
      // notify any listeners on the app side
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function processUpsellList(listRoot) {
    const area = readAreaM2();
    if (!area) return;
    const cards = $$(listRoot, 'lb-upsell-flat-card.lb-product-card, .lb-flat-card-host.lb-product-card');
    if (!cards.length) return;

    cards.forEach(card => updateCardQuantity(card, area));

    // Also watch variant dropdown changes inside the cards (weight may change per variant)
    cards.forEach(card => {
      const sel = card.querySelector('.lb-variant-picker select');
      if (sel && !sel.dataset.wotBound) {
        sel.addEventListener('change', () => {
          // lb-variant-id may or may not update; we always re-read extractVariantId()
          updateCardQuantity(card, readAreaM2());
        });
        sel.dataset.wotBound = '1';
      }
    });
  }

  // ---------- observer: wait for popup ----------
  function tryProcessAll() {
    // The upsell container often includes a .lb-list with many cards
    const lists = document.querySelectorAll('.lb-list');
    lists.forEach(l => processUpsellList(l));
  }

  const observer = new MutationObserver(debounce(() => {
    tryProcessAll();
  }, 120));

  observer.observe(document.documentElement, { childList: true, subtree: true });

  // Run once on load as well
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryProcessAll, { once: true });
  } else {
    tryProcessAll();
  }

  // If the area input changes after user edits, recompute
  const areaInput = document.querySelector('.m2-input-section input[type="number"], .m2-input-section input');
  if (areaInput) {
    ['input', 'change'].forEach(ev =>
      areaInput.addEventListener(ev, debounce(tryProcessAll, 200))
    );
  }
})();



